import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';

type StepKind = 'sales' | 'financing' | 'collections';

export function StepProductMockup({
  step,
}: {
  step: StepKind;
}): React.JSX.Element {
  const { t } = useTranslation('home');
  const content = {
    sales: {
      heading: t('homePage.productMockups.steps.sales.heading'),
      rows: [
        t('homePage.productMockups.steps.sales.rows.qualifiedLead'),
        t('homePage.productMockups.steps.sales.rows.linkedUnit'),
        t('homePage.productMockups.steps.sales.rows.issuedProforma'),
      ],
      aside: t('homePage.productMockups.steps.sales.aside'),
    },
    financing: {
      heading: t('homePage.productMockups.steps.financing.heading'),
      rows: [
        t('homePage.productMockups.steps.financing.rows.schedule'),
        t('homePage.productMockups.steps.financing.rows.pendingNote'),
        t('homePage.productMockups.steps.financing.rows.registeredPayment'),
      ],
      aside: t('homePage.productMockups.steps.financing.aside'),
    },
    collections: {
      heading: t('homePage.productMockups.steps.collections.heading'),
      rows: [
        t('homePage.productMockups.steps.collections.rows.highRisk'),
        t('homePage.productMockups.steps.collections.rows.nextAction'),
        t('homePage.productMockups.steps.collections.rows.availableEvidence'),
      ],
      aside: t('homePage.productMockups.steps.collections.aside'),
    },
  }[step];

  return (
    <div className="w-full rounded-[1.5rem] border border-brand-primary/10 bg-white p-4 shadow-frontpage-card">
      <div className="rounded-[1rem] border border-brand-primary/10 bg-brand-bg p-4">
        <div className="mb-4 flex items-center justify-between">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-brand-accent-ink">
            {content.heading}
          </p>
          <span className="rounded-full bg-white px-3 py-1 text-xs font-bold uppercase tracking-[0.1em] text-brand-teal">
            {content.aside}
          </span>
        </div>
        <div className="space-y-3">
          {content.rows.map((row, index) => (
            <div
              key={row}
              className="grid grid-cols-[auto_1fr_auto] items-center gap-3 rounded-xl border border-brand-primary/10 bg-white px-4 py-3"
            >
              <span
                className="font-mono text-xs text-brand-accent-ink"
                aria-hidden="true"
              >
                0{index + 1}
              </span>
              <span className="text-sm font-semibold text-brand-primary">
                {row}
              </span>
              <span
                className={cn(
                  'h-2 w-10 rounded-full',
                  index === 0 ? 'bg-brand-teal' : 'bg-brand-primary/10'
                )}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
